export enum Roles {
    User = 'User',
    Assistant = 'Assistant',
    Admin = 'Admin',
    SuperAdmin = 'SuperAdmin'
}